import Vue from 'vue';
import Vuex from 'vuex';

import formErrors from './modules/form-errors.js';
import Application from './modules/Application.js';
import IdentityDoc from './modules/IdentityDoc.js';
import Clients from './modules/Clients.js';
import Finance from './modules/Finance.js';
import Employee from './modules/Employee.js';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        formErrors,
        IdentityDoc,
        Application,
        Clients,
        Finance,
        Employee
    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js